import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { siteInfo, practiceAreas, paralegalServices } from '../data';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-grid">
        {/* Brand Column */}
        <div className="footer-brand">
          <Link to="/">
            <img src={siteInfo.logoFull} alt={siteInfo.name} className="footer-logo" />
          </Link>
          <p className="footer-desc">{siteInfo.footerDescription}</p>
          <a href={`tel:${siteInfo.phone}`} className="footer-phone">
            <Phone size={16} /> {siteInfo.phoneDisplay}
          </a>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h4 className="footer-heading">Quick Links</h4>
          <ul>
            <li><Link to="/paralegal-services">Paralegal Services</Link></li>
            <li><Link to="/area-practice">Area of Practice</Link></li>
            <li><Link to="/contact-us">Contact Us</Link></li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-col">
          <h4 className="footer-heading">Services</h4>
          <ul>
            {practiceAreas.map((area) => (
              <li key={area.slug}>
                <Link to={`/${area.slug}`}>{area.shortTitle}</Link>
              </li>
            ))}
            {paralegalServices.map((svc) => (
              <li key={svc.slug}>
                <Link to={`/${svc.slug}`}>{svc.shortTitle}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>{siteInfo.copyright}</p>
        </div>
      </div>
    </footer>
  );
}
